import { Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import FormikDropdown from "src/components/Common/UI/Formik/FormkDropdown";
import FormikTextbox from "src/components/Common/UI/Formik/FormikTextbox";
import UnitSearchFormItems from "../UnitSearchFormItems";
import { useGetAllCitiesList } from "../../Parameters/Geographicals/Cities/api/getAllCitiesList";
import { useGetAllAreasList } from "../../Parameters/Geographicals/Areas/api/getAllAreasList";
import { useGetAllPlacesList } from "../../Parameters/Geographicals/Places/api/getAllPlacesList";
import FormikReactSelect from "src/components/Common/UI/Formik/FormikSelect";


const EstablishmentSearchForm = ({ initialValues, onSubmit, onClearForm }: EstablishmentSearchFormProps) => {
  const { t } = useTranslation();

  const getAllCitiesListQuery = useGetAllCitiesList();
  const getAllAreasListQuery = useGetAllAreasList();
  const getAllPlacesListQuery = useGetAllPlacesList();

  const placeList = getAllPlacesListQuery.data?.map(place => ({
    value: place.id,
    label: place.name,
  })) || [];

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values, formikHelpers) => {
        onSubmit(values, formikHelpers);
      }}
    >
      {({ isSubmitting, resetForm }) => (
        <Form>
          <Container fluid className="p-0">
            <Row> 
              <Col xs={6}>
                <FormikTextbox
                  label={"Ονομασία"}
                  fieldName={"description"}
                />
              </Col>

              <Col xs={6}>
                <FormikTextbox
                  label={"Κωδικός SAP"}
                  fieldName={"sapCode"}
                />
              </Col>
              
              <Col xs={6} className="d-none">
                <FormikDropdown 
                  label={t("Πόλη")} 
                  fieldName={"cityID"}
                  disabled={true}
                >
                  <option value="">{t("Επιλέξτε Πόλη")}</option>
                  {getAllCitiesListQuery.data &&
                    getAllCitiesListQuery.data.map((city) => (
                      <option key={city.id} value={city.id}>
                        {city.description}
                      </option>
                    ))
                  }
                </FormikDropdown>
              </Col>

              <Col xs={6} className="d-none">
                <FormikDropdown 
                  label={t("Περιοχή")} 
                  fieldName={"areaID"}
                  disabled={true}
                >
                  <option value="">{t("Επιλέξτε Περιοχή")}</option>
                  {getAllAreasListQuery.data &&
                    getAllAreasListQuery.data.map((area) => (
                      <option key={area.id} value={area.id}>
                        {area.description}
                      </option>
                    ))
                  }
                </FormikDropdown>
              </Col>

              <Col xs={6}>
                <FormikTextbox 
                  label={"Κωδικός καταστήματος"} 
                  fieldName={"unID"}
                />
              </Col>

              {/* <Col xs={6}>
                <FormikDropdown 
                  label={t("Tοποθεσία")} 
                  fieldName={"placeID"}
                >
                  <option value="">{t("Επιλέξτε Τοποθεσία")}</option>
                  {getAllPlacesListQuery.data &&
                    getAllPlacesListQuery.data.map((place) => (
                      <option key={place.id} value={place.id}>
                        {place.name}
                      </option>
                    ))
                  }
                </FormikDropdown>
              </Col> */}

              <Col xs={6}>
                <FormikReactSelect
                  label="Τοποθεσία"
                  fieldName="placeID"
                  options={placeList}
                  placeholder="Επιλέξτε Τοποθεσία"
                />
              </Col>

              <Col xs={6}>
                <FormikDropdown 
                  label={t("Διαγραμμένα")} 
                  fieldName={"deleted"}
                >
                  <option value="">{t("Όχι")}</option>
                  <option value="true">{t("Ναι")}</option>
                </FormikDropdown>
              </Col>

            </Row>
            <Row className="row justify-content-end">
              <Col xs="2" className="m-2 me-0">
                <Button
                  type="button"
                  size="sm"
                  color="warning"
                  disabled={isSubmitting}
                  onClick={onClearForm}
                >
                  {t("Καθαρισμός")}
                </Button>
              </Col>

              <Col xs="2" className="m-2">
                <Button
                  type="submit"
                  size="sm"
                  color="primary"
                  disabled={isSubmitting}
                >
                  {t("Αναζήτηση")}
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      )}
    </Formik>
  )
}

export default EstablishmentSearchForm;

type EstablishmentSearchFormProps = {
  initialValues: IEstablishmentSearchForm;
  onSubmit: (
    values: IEstablishmentSearchForm,
    formikHelpers: FormikHelpers<IEstablishmentSearchForm>
  ) => void;
  onClearForm: () => void;
}